exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn.btn-default {\r\n  text-align: center;\r\n  cursor: pointer;\r\n  font-size: 24px;\r\n  line-height: 1.33;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .btn-circle.btn-default {\r\n    border-radius: 35px;\r\n  }\r\n\r\n  .btn.btn-default {\r\n    width: 70px;\r\n    height: 70px;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .btn-circle.btn-default {\r\n    border-radius: 25px;\r\n  }\r\n\r\n  .btn.btn-default {\r\n    width: 50px;\r\n    height: 50px;\r\n  }\r\n\r\n  .hr-bar {\r\n    margin-top: 1.56rem;\r\n    left: 25px;\r\n    right: 25px;\r\n  }\r\n}\r\n\r\n.max-height {\r\n  height: 100%;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .align-right {\r\n    text-align: right !important;\r\n  }\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/flow/flow.component.css
// module id = ../../../../../src/app/flow/flow.component.css
// module chunks = main